import { guideSteps } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-14 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="观看指南"
          title="四步上手，把碎片时间花在好内容上"
          desc="不用注册、不用搜索多个平台，按照下面四步，就能在本页高效找到并连续观看想看的小视频。"
        />

        <ol className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((item) => (
            <li
              key={item.step}
              className="relative rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="font-heading text-3xl font-extrabold text-primary-500">{item.step}</span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}